'use strict';

var getInferredName;
try {
	// eslint-disable-next-line no-new-func
	getInferredName = Function('s', 'return { [s]() {} }[s].name;');
} catch (e) {}

var inferred = function () {};
module.exports = getInferredName && inferred.name === 'inferred' ? getInferredName : null;



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/getInferredName.js
// module id = 1104
// module chunks = 1